import styled from 'styled-components';
import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
const { playerControlsThemes: themes } = Colors;

export const StyledPlayerControls = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  box-sizing: border-box;
  align-items: center;
  padding: 6px;
  width: calc(100% - 10px);
  border-radius: 3px;
  color: ${(props) => themes[props.theme].foreground};
  background-color: ${(props) => themes[props.theme].background};
  position: absolute;
  bottom: 6px;
  left: 4px;
  right: 4px;
  z-index: 100;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => themes[props.theme].backgroundHover};
  }
  &.can-seek .progress-bar {
    cursor: pointer;

    &:hover {
      .ant-progress-bg,
      .ant-progress-success-bg {
        transition: all 0.2s ease-in-out;
        opacity: 0.7;
      }
    }
  }
  .player-button {
    color: ${(props) => themes[props.theme].buttonsForeground};
    background-color: ${(props) => themes[props.theme].buttonsBackground};
    border: none;
    border-radius: 4px;
    line-height: 1;
    &:hover {
      color: ${(props) => themes[props.theme].buttonsForegroundHover};
      background-color: ${(props) =>
        themes[props.theme].buttonsBackgroundHover};
    }
  }

  .progress-bar {
    flex: 1;
    position: relative;
    .ant-progress {
      .ant-progress-inner {
        background-color: ${(props) => themes[props.theme].progressBarBgColor};
        .ant-progress-success-bg {
          background-color: ${(props) => themes[props.theme].progressBarColor};
        }
        .ant-progress-bg {
          background-color: ${(props) => themes[props.theme].bufferBarColor};
        }
      }
    }
    .cue-points {
      width: 100%;
      .point {
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 2px;
        background-color: ${(props) => themes[props.theme].lightForeground};
        transform: translateX(-2px);
        &.current {
          width: 8px;
          height: 8px;
          margin-top: -2px;
          border-top-left-radius: 2px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 4px;
          border-bottom-left-radius: 4px;
          transform: translateX(-4px);
        }
      }
    }
  }
  .time {
    color: ${(props) => themes[props.theme].foreground};
    padding: 2px 6px 2px 12px;
    border-radius: 4px;
    background-color: ${(props) => themes[props.theme].textBackground};
  }

  .height-select {
    .ant-select-selector {
      color: ${(props) => themes[props.theme].foreground};
      background-color: ${(props) => themes[props.theme].textBackground};
      border: none;
    }
    .ant-select-arrow {
      color: ${(props) => themes[props.theme].foreground};
      pointer-events: none !important;
      * {
        pointer-events: none !important;
      }
    }
  }
  .playback-rate-select {
    .ant-select-selector {
      background-color: ${(props) => themes[props.theme].textBackground};
      color: ${(props) => themes[props.theme].foreground};
      border: none;
    }
    .ant-select-arrow {
      pointer-events: none !important;
      * {
        pointer-events: none !important;
      }
    }
  }
  .controls-wrapper {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;

    .other-controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 5px;
    }
  }

  &.fullscreen-controls {
    .player-button {
      height: 40px;
      padding: 0px 20px;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    justify-content: space-between;
    .controls-wrapper {
      flex-direction: column;
      gap: 0px;
      align-items: flex-end;
      .progress-bar {
        width: 100%;
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}) {
    .speed-text {
      display: none;
    }
  }
`;
